import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";

import i18n from "../../i18n";
import { renderHtml } from "../../helpers";
import tracking from "../../tracking/tracking";

export default function FAQ({ items }) {
  const collapsible = useRef(null);
  useEffect(() => {
    var elems = document.querySelectorAll(".collapsible");
    M.Collapsible.init(elems, {
      onOpenStart: (elem) => {
        tracking.track("faq.open", {
          title: elem.querySelector(".collapsible-header").innerText,
        });
      },
    });
  }, []);
  return (
    <section class="row row--unpadded">
      <div class="col s12">
        <h1 class="t-h3 t-h3--margin">{i18n.t("component.faq.title")}</h1>

        <ul ref={collapsible} class="collapsible z-depth-0">
          {items.map((item) => (
            <li>
              <div class="collapsible-header">
                {item.question}{" "}
                <span class="material-symbols-rounded collapse-opened">
                  remove
                </span>
                <span class="material-symbols-rounded collapse-closed">
                  add
                </span>
              </div>
              <div class="collapsible-body">
                <span>{renderHtml(item.answer)}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
